import { applyMiddleware, combineReducers, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import logger from 'redux-logger';
import { createPromise } from 'redux-promise-middleware';
import thunk from 'redux-thunk';
import {
  currentUserReducers,
  datesReducer,
  daysInWeekReducer,
  overtimeReducer,
  projectStatisticReducer,
  projectsDropdownReducer,
  projectsWeeklyHoursReducers,
  requestsReducer,
  rolesReducer,
  selectedUserReducer,
  vacationsReducer,
} from './reducers';
import { categoriesReducer } from './reducers/categories';
import { deskLabelsReducer } from './reducers/desk-bookings';
import { emailSubscriptionsReducer } from './reducers/email-subscriptions';
import { errorReducer } from './reducers/error';
import { holidaysReducer } from './reducers/holidays';
import { unresolvedIncidentsCountReducer } from './reducers/incidents';
import { loaderReducer } from './reducers/loader';
import { logsReducers } from './reducers/logs';
import { modalReducer } from './reducers/modal';
import { notificationsReducer } from './reducers/notifications';
import { projectsReducer } from './reducers/projects';
import { usersReducer } from './reducers/users';
import workSessionsReducer from './reducers/work-sessions';
import type { InitialStateConfigure } from '../types';

export default (initialState: InitialStateConfigure, disableLogger: boolean): any => {
  const middleware = [thunk, createPromise()];
  const isDevelopment = process.env.NODE_ENV === 'development';

  if (isDevelopment && !disableLogger) {
    middleware.push(logger);
  }

  const middlewareApplyer = isDevelopment ? composeWithDevTools(applyMiddleware(...middleware)) : applyMiddleware(...middleware);

  return createStore(
    combineReducers({
      logs: logsReducers,
      dates: datesReducer,
      daysInWeek: daysInWeekReducer,
      users: usersReducer,
      projects: projectsReducer,
      currentUser: currentUserReducers,
      roles: rolesReducer,
      selectedUser: selectedUserReducer,
      requests: requestsReducer,
      displayLoader: loaderReducer,
      error: errorReducer,
      projectsDropdown: projectsDropdownReducer,
      projectStatistics: projectStatisticReducer,
      categories: categoriesReducer,
      notifications: notificationsReducer,
      projectsWeeklyHours: projectsWeeklyHoursReducers,
      holidays: holidaysReducer,
      modal: modalReducer,
      vacations: vacationsReducer,
      overtime: overtimeReducer,
      subscriptions: emailSubscriptionsReducer,
      workSessions: workSessionsReducer,
      deskLabels: deskLabelsReducer,
      unresolvedIncidentsCount: unresolvedIncidentsCountReducer,
    }),
    initialState,
    middlewareApplyer,
  );
};
